
import { mapActions, mapState } from 'vuex'
import { mdiRvTruck } from '@mdi/js'
import utils from '@/components/tools/utils'
export default {
  props: {
    auctionId: {
      default: undefined,
      type: Number
    },
    size: {
      default: undefined,
      type: Number
    }
  },
  data () {
    return {
      mdiRvTruck
    }
  },
  async fetch () {
    try {
      if (this.auctionId !== undefined) {
        await this.getProductByAuctionId(this.auctionId)
      }
    } catch (e) {
      console.error(e)
    }
  },

  computed: {
    ...mapState('catalog', {
      auctions (state) {
        return state.auctions
      }
    }),
    imageUri () {
      return utils.imageUri(this, this.auctions[this.auctionId]?.image)
    },
    image () {
      return this.auctions[this.auctionId]?.image
    }
  },
  methods: {
    ...mapActions('catalog', [
      'getProductByAuctionId'
    ])
  }
}
